const interpolate = (template: string, params?: Record<string, unknown>): string => {
	if (!params) return template;
	return template.replace(/\{\{(.*?)\}\}/g, (_, key) => {
		const value = params[key.trim()];
		return value != null ? String(value) : "";
	});
};

export const resolveNestedMessage = (
	messages: Record<string, unknown>,
	key: string,
	params?: Record<string, unknown>,
): string | undefined => {
	let current: unknown = messages;

	for (const part of key.split(".")) {
		if (typeof current !== "object" || current === null) return undefined;
		current = (current as Record<string, unknown>)[part];
	}

	return typeof current === "string" ? interpolate(current, params) : undefined;
};
